import * as z from "zod/v4";

export const createGoogleAdsUserList = {
  name: "createGoogleAdsUserList" as const,
  input: z.object({ customerId: z.string(), name: z.string() }),
  output: z.object({
    userList: z.object({ id: z.string(), name: z.string() }).nullable(),
  }),
};
